import ApiService from '../services/ApiService';
import * as types from './ActionTypes';
import { goToErrorPage, getIdentities } from './GenericActions';

export const requestContactWays = identitiesId => ({
  type: types.GET_CONTACTS,
  identitiesId,
});

export const getContactsSuccess = ({ identities, contacts, step }) => ({
  type: types.GET_CONTACTS_SUCCESS,
  payload: {
    identities,
    contacts,
    step,
  },
  receivedAt: Date.now(),
});

export const getContactsFailure = error => ({
  type: types.GET_CONTACTS_FAILURE,
  error,
  receiveAt: Date.now(),
});

export const setSelectedContact = contact => ({
  type: types.SET_SELECTED_CONTACT,
  payload: { contact },
  changedAt: Date.now(),
});

export const clearContacts = () => ({
  type: types.CLEAR_CONTACTS,
});

export const getContacts = () => (dispatch, getState) => {
  const { identitiesId } = getState().identification;
  const { identities } = getState().choice;

  dispatch(requestContactWays(identitiesId));
  return ApiService.getIdentitiesContacts({ identitiesId }).then(
    (res) => {
      const { data, step } = res.data;
      dispatch(getContactsSuccess({ identities, contacts: data, step }));
    },
    (err) => {
      dispatch(getContactsFailure(err.response));
      dispatch(goToErrorPage());
    },
  );
};

export const getIdentitiesAndContacts = () => (dispatch, getState) => {
  const { identitiesId } = getState().identification;

  dispatch(getIdentities(identitiesId)).then(() => dispatch(getContacts(identitiesId)));
};
